export default "__VITE_ASSET__BWp9fstz__"